/**
 * 大屏显示首页
 */
import React from 'react';

import {  Icon } from 'antd';

import "../../../style/largeScreen/index.css";

import DealData from './DealData';  // 交易数据
//todo
import ChartBarData from './ChartBarData';  // 交易地图
import ChartBarTwo from './ChartBarTwo';

class Index extends React.Component {

    state = {
        isFullScreen: false,
        darkBackground: false,
        carouselIndex: 0
    }
    //大屏轮播时间
    componentDidMount() {
        this.interval = setInterval(() => this.timer(), 15000*1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    timer = () =>{
        let {carouselIndex} = this.state;
        carouselIndex = carouselIndex === 2 ? 0:(carouselIndex+1);
        this.setState({carouselIndex: carouselIndex});
    }

    //进入全屏
    requestFullScreen = () => {
        var de = document.documentElement;
        if (de.requestFullscreen) {
            de.requestFullscreen();
        } else if (de.mozRequestFullScreen) {
            de.mozRequestFullScreen();
        } else if (de.webkitRequestFullScreen) {
            de.webkitRequestFullScreen();
        }
        this.setState({ isFullScreen: true });
    };

    //退出全屏
    exitFullscreen = () => {
        var de = document;
        if (de.exitFullscreen) {
            de.exitFullscreen();
        } else if (de.mozCancelFullScreen) {
            de.mozCancelFullScreen();
        } else if (de.webkitCancelFullScreen) {
            de.webkitCancelFullScreen();
        }
        this.setState({ isFullScreen: false });
    };

    carouselClick = (info, e) =>{
        this.setState({carouselIndex: info});
    }

    render() {
        let carouselRight = (this.state.carouselIndex * 100) + '%';
        return (
            <div className="large-screen-container">
                <div style={{ zIndex: 10, position: 'absolute', width: '20px', height: '20px', right: 0 }}>
                    {this.state.isFullScreen ?
                        <Icon type="fullscreen-exit" style={{ color: '#000000', fontSize: '20px' }} onClick={this.exitFullscreen.bind(this)} />
                        :
                        <Icon type="fullscreen" style={{ color: '#000000', fontSize: '20px' }} onClick={this.requestFullScreen.bind(this)} />
                    }
                </div>
                
                <div className="def-carousel-btn-container">
                    <div style={{right: '47px', position: 'relative'}}>
                        <div className={`def-carousel-btn ${this.state.carouselIndex===0?'active':''} `} onClick={this.carouselClick.bind(this,0)}></div>
                        <div className={`def-carousel-btn ${this.state.carouselIndex===1?'active':''} `} onClick={this.carouselClick.bind(this,1)}></div>
                        <div className={`def-carousel-btn ${this.state.carouselIndex===2?'active':''} `} onClick={this.carouselClick.bind(this,2)}></div>
                    </div>
                </div>
                
                <div style={{ transition: 'all 500ms', right: carouselRight }} className="def-carousel-container">
                    <div className="div-container">
                        <ChartBarData
                            requestFullScreen={this.requestFullScreen}
                            exitFullscreen={this.exitFullscreen}
                            isFullScreen={this.state.isFullScreen}
                        />
                    </div>
                    <div className="div-container">
                        <ChartBarTwo
                            requestFullScreen={this.requestFullScreen}
                            exitFullscreen={this.exitFullscreen}
                            isFullScreen={this.state.isFullScreen}
                        />
                    </div>
                    <div className="div-container">
                        <DealData
                            requestFullScreen={this.requestFullScreen}
                            exitFullscreen={this.exitFullscreen}
                            isFullScreen={this.state.isFullScreen}
                        />
                    </div>
                    {/* <div className="div-container">
                        <DealChart
                            requestFullScreen={this.requestFullScreen}
                            exitFullscreen={this.exitFullscreen}
                            isFullScreen={this.state.isFullScreen}
                            darkBackground={this.state.darkBackground}
                        />
                    </div> */}
                    {/* <div className="div-container">
                        <ChartMap
                            requestFullScreen={this.requestFullScreen}
                            exitFullscreen={this.exitFullscreen}
                            isFullScreen={this.state.isFullScreen}
                            darkBackground={this.state.darkBackground}
                        />
                    </div> */}
                </div>
                {/* <Carousel>
                    <div className="div-container">
                        <DealChart
                            requestFullScreen={this.requestFullScreen}
                            exitFullscreen={this.exitFullscreen}
                            isFullScreen={this.state.isFullScreen}
                            darkBackground={this.state.darkBackground}
                        />
                    </div>
                    <div className="div-container">
                        <ChartMap
                            requestFullScreen={this.requestFullScreen}
                            exitFullscreen={this.exitFullscreen}
                            isFullScreen={this.state.isFullScreen}
                            darkBackground={this.state.darkBackground}
                        />
                    </div>
                    <div className="div-container">
                        <DealData
                            requestFullScreen={this.requestFullScreen}
                            exitFullscreen={this.exitFullscreen}
                            isFullScreen={this.state.isFullScreen}
                        />
                    </div>
                </Carousel> */}
            </div>
        )
    }
}

export default Index;